import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconeMapa from '../../../../assets/img/icones/personalizados/mapa-cor.svg';

const CardEndereco = ({
  item,
  abreModalExcluir,
  chamaAlterarEndereco,
  tornaPrincipal,
}) => {
  const { t } = useTranslation();
  var enderecoBanco = '';
  enderecoBanco = item.logradouro + ', ' + item.numero;
  if (item.complemento) {
    enderecoBanco += ', ' + item.complemento;
  }
  if (item.bairro) {
    enderecoBanco += ', ' + item.bairro;
  }
  enderecoBanco += ', ' + item.cidade + ', ' + item.uf + ', ' + item.nomePais;
  const nomeEndereco = item.identificacao;
  return (
    <>
      {item.principal === 'S' ? (
        <div className="card-endereco principal card bg-superficie elev1">
          <div className="icone-titulo-principal">
            <img
              className="img-card"
              alt="ícone de mapa com pin"
              src={iconeMapa}
            />

            <h6>{t('principal.addresses.main_address')}</h6>
          </div>

          <div className="card-descricao">
            <b>{nomeEndereco}</b>
            <br />
            {enderecoBanco}
          </div>

          <div className="btns-container">
            <button
              className="btn-txt so-icone"
              onClick={() => chamaAlterarEndereco(item)}
            >
              <i className="ic-editar"></i>
            </button>

            <button
              className="btn-txt so-icone "
              onClick={() => abreModalExcluir(item)}
            >
              <i className="ic-lixo"></i>
            </button>
          </div>
        </div>
      ) : (
        <div className="card-endereco card bg-superficie elev1">
          <div className="card-descricao">
            <b>{nomeEndereco}</b>
            <br />
            {enderecoBanco}
          </div>

          <div className="btns-container">
            <button className="btn-txt" onClick={() => tornaPrincipal(item)}>
              <i className="ic-estrela"></i>{t('principal.addresses.make_main')}
            </button>

            <button
              className="btn-txt so-icone"
              onClick={() => chamaAlterarEndereco(item)}
            >
              <i className="ic-editar"></i>
            </button>

            <button
              className="btn-txt so-icone "
              onClick={() => abreModalExcluir(item)}
            >
              <i className="ic-lixo"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CardEndereco;
